export default __webpack_public_path__ + "static/media/play-button.bf56e0b5.svg";